export default from './PageNav';



// WEBPACK FOOTER //
// ./src/components/NonAuthHomePage/components/Description/components/PageNav/index.js